<script setup lang="ts">
import { CarouselSlideWide } from '~/lib/services/content/content.blocks.dtos'

const props = defineProps<{ slide: CarouselSlideWide }>()
// const isMobile = inject('isMobile')

// TODO: add image mobile and desktop
const slideImgSrc = computed(() => `${props.slide.image.url}`)

const buttonPosition = computed(() => {
  if (!props.slide.buttonAction) return undefined
  const arr = props.slide.buttonCustomPosition.split(',')
  const [x, y] = arr
  return {
    x,
    y,
  }
})
</script>

<template>
  <div class="relative h-full">
    <img
      class="h-full w-full object-contain sm:max-h-[328px] md:max-h-[340px] lg:max-h-none"
      :src="slideImgSrc"
      :alt="slide.image.alternativeText || undefined"
    />

    <!-- Button in custom position -->
    <div
      v-if="slide.buttonAction"
      class="absolute"
      :style="`top:${buttonPosition?.y};left:${buttonPosition?.x};transform:translate(-${buttonPosition?.x},-${buttonPosition?.y})`"
    >
      <!-- SimpleLink -->
      <SimpleLink :link="slide.buttonAction">
        <button class="btn-primary">{{ slide.buttonAction.title || 'Action' }}</button>
      </SimpleLink>
    </div>
  </div>
</template>
